import axios from '@/plugins/axios';

// 鉴证报告列表
export function notarizationList(params) {
  return axios.get('/notarization/notarizationList', {
    params: params
  });
}

// 获取需要做鉴证报告的项目详细信息
export function getDoNotarizationProjectInfo(params) {
  return axios.get('/notarization/getDoNotarizationProjectInfo', {
    params: params
  });
}

// 保存合规鉴证申请支付信息
export function saveNotarization(params) {
  return axios.post('/notarization/saveNotarization', params);
}

// 获取已选中项目合规鉴证申请信息
export function getNotarizationInfo(params) {
  return axios.get('/notarization/getNotarizationInfo', {
    params: params
  });
}

// 系统管理员查询鉴证数据列表
export function findSysNotarizationList(params) {
  return axios.post('/notarization/findSysNotarizationList', params);
}

// 系统管理员根据applyId获取鉴证申请信息
export function findNotarizationById(applyId) {
  return axios.get('/notarization/findNotarizationById', {
    params: {
      applyId: applyId
    }
  });
}

// 系统管理员更新鉴证数据信息
export function updateNotarizationStatus(params) {
  return axios.post('/notarization/updateNotarizationStatus', params);
}

// 根据订单号查询项目相关信息
export function findProjectInfoByOrderNum(sysOrderNumber) {
  return axios.get('/notarization/findProjectInfoByOrderNum', {
    params: {
      sysOrderNumber: sysOrderNumber
    }
  });
}
